import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// ── Auth ──
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute   from "./auth/ProtectedRoute";

// ── Toast ──
import { ToastProvider } from "./components/ToastContext";

// ── Auth Pages ──
import Login    from "./pages/Login";
import Register from "./pages/Register";

// ── Admin Layout ──
import AdminLayout from "./admin/components/AdminLayout";

// ── Admin Pages ──
import Dashboard         from "./admin/pages/Dashboard";
import AdminProjects     from "./admin/pages/AdminProjects";
import AdminServices     from "./admin/pages/AdminServices";
import AdminTeam         from "./admin/pages/AdminTeam";
import AdminTestimonials from "./admin/pages/AdminTestimonials";
import AdminTech         from "./admin/pages/AdminTech";
import AdminPricing      from "./admin/pages/AdminPricing";
import AdminContent      from "./admin/pages/AdminContent";
import AdminMessages     from "./admin/pages/AdminMessages";
import AdminUsers        from "./admin/pages/AdminUsers";
import { AdminSettings } from "./admin/pages/AdminStub";

// ── Public Layout Components ──
import TopBar      from "./components/TopBar";
import Navbar      from "./components/Navbar";
import Footer      from "./components/Footer";
import ChatBot     from "./components/ChatBot";
import ScrollToTop from "./components/ScrollToTop";
import Privacy     from "./pages/Privacy";
import Terms       from "./pages/Terms";
import CookieBanner from "./components/CookieBanner";

// ── Public Pages ──
import Home         from "./pages/Home";
import About        from "./pages/About";
import Portfolio    from "./pages/Portfolio";
import Contact      from "./pages/Contact";
import Services     from "./pages/Services";
import TechStack    from "./pages/TechStack";
import Team         from "./pages/Team";
import Testimonials from "./pages/Testimonials";

// ── Public Layout ─────────────────────────────────────────────────────────────
const PublicLayout = ({ children }) => (
  <>
    <TopBar />
    <Navbar />
    <main style={{ minHeight: "80vh", paddingTop: "114px" }}>
      {children}
    </main>
    <Footer />
    <ChatBot />
    <ScrollToTop />
  </>
);

// ── App ───────────────────────────────────────────────────────────────────────
function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <AuthProvider>
        <ToastProvider>
          <Router>
            <Routes>

              {/* Auth */}
              <Route path="/login"    element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Admin Panel */}
              <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminLayout /></ProtectedRoute>}>
                <Route index              element={<Dashboard />} />
                <Route path="dashboard"   element={<Dashboard />} />
                <Route path="projects"    element={<AdminProjects />} />
                <Route path="services"    element={<AdminServices />} />
                <Route path="team"        element={<AdminTeam />} />
                <Route path="testimonials"element={<AdminTestimonials />} />
                <Route path="tech"        element={<AdminTech />} />
                <Route path="pricing"     element={<AdminPricing />} />
                <Route path="messages"    element={<AdminMessages />} />
                <Route path="users"       element={<AdminUsers />} />
                <Route path="content"     element={<AdminContent />} />
                <Route path="settings"    element={<AdminSettings />} />
              </Route>

              {/* Public Pages */}
              <Route path="/"            element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/about"       element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/portfolio"   element={<PublicLayout><Portfolio /></PublicLayout>} />
              <Route path="/contact"     element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/services"    element={<PublicLayout><Services /></PublicLayout>} />
              <Route path="/tech-stack"  element={<PublicLayout><TechStack /></PublicLayout>} />
              <Route path="/team"        element={<PublicLayout><Team /></PublicLayout>} />
              <Route path="/testimonials"element={<PublicLayout><Testimonials /></PublicLayout>} />
              <Route path="/privacy"     element={<PublicLayout><Privacy /></PublicLayout>} />
              <Route path="/terms"       element={<PublicLayout><Terms /></PublicLayout>} />
              <Route path="*"            element={<PublicLayout><Home /></PublicLayout>} />

            </Routes>

            {/* Cookie Banner — handles blocking and navigation guard */}
            <CookieBanner />

          </Router>
        </ToastProvider>
      </AuthProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;